import React from 'react';
import './Post.scss';
import { Modal } from 'components';
import ReactTooltip from 'react-tooltip';
import { IconInformation, IconClose } from '../../img';

const PostModel = ({
  data,
  closeModal,
  hanStateChg,
  updatePost, removeArrChips, addHtg
}) => {
  return (
    <div>
      <Modal
        id='NotificationModal'
        className='appconnectmodal appgooglemodal'
        title=''
        content={
          <div className="modal-body ">
            <div className="modal-app-content">
              <form className="app-connect app-connect-google">
                <div className="nf-group-input mt-25">
                  <label>Message</label>
                  <div className="tootltip seeting-tooltip">
                    <img data-tip data-for='msg' src={IconInformation} alt="" />
                    <ReactTooltip id='msg' aria-haspopup='true' role='example'>
                      <p>Enter Message</p>
                    </ReactTooltip>
                  </div>
                  <input type="text" name="msg" className="nf-input" id="" placeholder="Message" value={data.msg} onChange={hanStateChg} />
                </div>
                <div className="nf-group-input mt-25">
                  <label>Hash Tag</label>
                  <div className="tootltip seeting-tooltip">
                    <img data-tip data-for='uphtg' src={IconInformation} alt="" />
                    <ReactTooltip id='uphtg' aria-haspopup='true' role='example'>
                      <p>Enter Hash Tag</p>
                    </ReactTooltip>
                  </div>
                  <input type="text" name="uphtg" className="nf-input" id="" placeholder="Hash Tag" value={data.uphtg}
                    onChange={hanStateChg} onKeyPress={(e) => addHtg(e)} />
                  {data.htg.length > 0 &&
                    <div>
                      <div className="integration-chips leaddata-chips">
                        <div className="chips-block">
                          <ul className="chips-list">
                            {data.htg.map((obj, i) =>
                              <li key={i}>{obj}<i onClick={() => removeArrChips(i)} className="cur-point"><img src={IconClose} /></i></li>
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <div className="nf-btn-login mt-10">
                  <button type='button' className="nf-btn  nf-btn-primary" onClick={() => updatePost(data._id)}>
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        }
        openCloseModal={() => closeModal()}
        style={
          {
            modalStyle: {
              display: data.ocPost ? 'block' : 'none',
              opacity: data.ocPost ? 1 : 0
            },
            alignModalStyle: {
              top: '210px'
            }
          }
        }
      />
    </div>
  );
};

export default PostModel;


// WEBPACK FOOTER //
// ./src/components/Post/PostModel.js